"use client";
import { useMemo, useState } from "react";
import { flatMap } from "lodash";
import {
	useCreateEdocSubsciptionEmail,
	useGetEdocsInfiniteQuery,
} from "@onair/operations";
import { useCourseFilter } from "../store";
import InfiniteScrollList, {
	InfiniteScrollListProps,
} from "@onair/ui/infinite-scroll-list";
import CardEdoc from "#src/components/edocs/card-edoc";
import DialogRegisterDocument, {
	DialogRegisterDocumentProps,
} from "#src/components/dialog-register-document";
import DialogSubscribeDocumentSuccess from "#src/components/dialog-register-document/dialog-subscribe-document-success";
import { EDocSubscriptionEmailDto, GetEdocsDto } from "@onair/repositories";
import { EDocumentQueryParams } from "@onair/services/e-document";
interface EDocListContainerProps {
	className?: string;
}
const EDocListContainer: React.FC<EDocListContainerProps> = ({ className }) => {
	const queryParams: EDocumentQueryParams = useCourseFilter((state) => {
		return {
			filter: state.q,
			limit: state.limit,
			offset: state.offset,
			orderField: state.orderField,
		};
	});
	const [selectedEDocument, setSelectedEDocument] = useState<GetEdocsDto>();
	const [isShowDialogSuccess, setShowDialogSuccess] = useState(false);

	const { data, fetchNextPage, isFetchingNextPage } =
		useGetEdocsInfiniteQuery(queryParams);
	const { mutate: subscribeEdoc, isPending } = useCreateEdocSubsciptionEmail();

	const edocList = useMemo(() => {
		const items = (data?.pages || []).map((page) => page.items);
		return flatMap(items);
	}, [data]);

	const handleFetchNextPage: InfiniteScrollListProps["onReachEnd"] = (
		isInview,
	) => {
		if (!isInview) return;

		fetchNextPage();
	};

	const handleSubmitRegisterEdoc: DialogRegisterDocumentProps["onSubmit"] = (
		formData,
	) => {
		if (!selectedEDocument) return;

		const payload: EDocSubscriptionEmailDto = {
			edocId: selectedEDocument?.id,
			email: formData.email,
			company: formData.company,
			isSubscribeEmailMKT: formData.isSubscribeEmailMKT,
			fullName: formData.fullName,
			phone: formData.phoneNumber,
		};
		subscribeEdoc(payload, {
			onSuccess(data, variables, context) {
				setShowDialogSuccess(true);
				setSelectedEDocument(undefined);
			},
		});
	};

	return (
		<div className={className}>
			<InfiniteScrollList
				onReachEnd={handleFetchNextPage}
				isFetchingNextPage={isFetchingNextPage}
			>
				<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-8">
					{edocList.map((item) => (
						<CardEdoc
							key={item.id}
							data={{
								title: item.title,
								bannerUrl: item.bannerUrl,
								downloadCount: item.downloadCount,
								fileSize: item.size,
								hashtags: item.hashtags,
								publishedAt: item.publishedAt,
								description: item.description,
							}}
							onClick={() => setSelectedEDocument(item)}
							className="rounded-xl overflow-hidden cursor-pointer aspect-[368/490]"
						/>
					))}
				</div>
			</InfiniteScrollList>
			<DialogRegisterDocument
				open={!!selectedEDocument}
				documentDescription={selectedEDocument?.description}
				documentName={selectedEDocument?.title}
				onSubmit={handleSubmitRegisterEdoc}
				onClose={() => setSelectedEDocument(undefined)}
			/>
			<DialogSubscribeDocumentSuccess
				open={isShowDialogSuccess}
				onClose={() => setShowDialogSuccess(false)}
			/>
		</div>
	);
};
export default EDocListContainer;
